import {RegionalReportResponse} from 'src/lib/api/regionalReport';

import {percentColor} from './colors';
import {primaryTargetPeriod} from './commentary';

const EXCEEDANCE_COLUMNS = [
  {quantile: 'discharge_q0.1', label: '90%'},
  {quantile: 'discharge_q0.25', label: '75%'},
  {quantile: 'discharge_q0.5', label: '50%'},
  {quantile: 'discharge_q0.75', label: '25%'},
  {quantile: 'discharge_q0.9', label: '10%'},
];

/**
 * Compact "All Sites" aggregated row for the Executive Summary: percent of
 * normal at each exceedance probability for the primary target period.
 */
export default function AggregatedSummaryRow({report}: {report: RegionalReportResponse}) {
  const primary = primaryTargetPeriod(report);
  if (!primary) return null;
  const agg = report.aggregated[primary.label];
  if (!agg) return null;

  const periodLabel = `${primary.label} ${report.forecastYear}`;

  return (
    <div className="mt-3 border border-gray-200 rounded-sm p-2 bg-gray-50">
      <div className="text-xs font-semibold text-gray-600 mb-1">
        All Sites
        {agg.siteCount != null && agg.siteCount < report.sitesIncluded
          ? ` (${agg.siteCount} of ${report.sitesIncluded})`
          : ''}{' '}
        — {periodLabel} (% of normal by exceedance probability)
      </div>
      <table className="text-xs w-full">
        <thead>
          <tr>
            {EXCEEDANCE_COLUMNS.map((col) => (
              <th key={col.quantile} className="text-right py-0.5 px-2 font-medium text-gray-500">
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {EXCEEDANCE_COLUMNS.map((col) => {
              const val = agg.percentOfNormal?.[col.quantile] ?? null;
              return (
                <td
                  key={col.quantile}
                  className={`text-right py-0.5 px-2 tabular-nums ${percentColor(val)}`}
                >
                  {val !== null ? Math.round(val) : '—'}
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
